/* pe-freeship.js – Free shipping bar (robusto, tema-agnóstico)
   - Detecta cambios por fetch/XHR/sections, inputs, botones +/- y mutaciones.
   - Polling inteligente: al detectar cambios, hace refrescos frecuentes por un tiempo.
   - Soporta múltiples barras a la vez (página y drawer).
   - Requiere elementos con [data-pe-freeship] y clases internas:
       .pe-fs-bar, .pe-fs-msg, .pe-fs-amount
   - Data attrs en el contenedor:
       data-goal-cents="7999000"
       data-basis="original|subtotal|total"
       data-pulse-threshold="70"
*/

(function(){
  const S = {
    hooked: false,
    mounted: new WeakSet(),
    lastHash: null,
    busy: false,
    debug: !!window.localStorage.peFSdebug
  };

  const log = (...a)=>{ if(S.debug) console.log('[pe-freeship]', ...a); };

  const money = (cents)=>{
    try{
      if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, '${{amount_no_decimals}}');
    }catch(e){}
    return '$' + Math.round((cents||0)/100).toLocaleString('es-CL');
  };

  async function getCart(){
    const r = await fetch('/cart.js', { headers:{'Accept':'application/json'}, cache:'no-store', keepalive:true });
    return r.json();
  }

  function basisOf(cart, basis){
    switch(basis){
      case 'subtotal': return cart.items_subtotal_price || 0;
      case 'total':    return cart.total_price || 0;
      case 'original':
      default:         return cart.original_total_price || cart.items_subtotal_price || 0;
    }
  }

  function cartHash(c){
    try{
      const items = (c.items||[]).map(i=>[i.id,i.quantity]).join('|');
      return [c.item_count, c.total_price, items].join('::');
    }catch(e){ return String(Math.random()); }
  }

  async function refreshEl(el){
    try{
      const goalAttr = el.getAttribute('data-goal-cents') || el.getAttribute('data-goal') || '0';
      let goalCents = parseInt(goalAttr,10);
      if(!goalCents){ // fallback si vino en CLP
        const goalClp = parseInt(goalAttr.replace(/\D/g,''),10) || 0;
        goalCents = goalClp * 100;
      }
      if(!goalCents){ log('Goal inválido'); return; }

      const basis = (el.getAttribute('data-basis')||'original');
      const pulseTh = parseInt(el.getAttribute('data-pulse-threshold')||'70',10);

      const bar = el.querySelector('.pe-fs-bar');
      const msg = el.querySelector('.pe-fs-msg');
      const amt = el.querySelector('.pe-fs-amount');

      const cart = await getCart();
      const used = basisOf(cart, basis); // centavos
      const pct  = Math.min(100, Math.max(0, Math.round((used/goalCents)*100)));
      const left = Math.max(0, goalCents - used);

      if (bar){
        // write twice por si el nodo entra con transition pendiente
        requestAnimationFrame(()=> bar.style.width = pct + '%');
        setTimeout(()=> bar.style.width = pct + '%', 60);
        if (pct >= pulseTh && pct < 100) bar.classList.add('pulse'); else bar.classList.remove('pulse');
      }
      if (amt) amt.textContent = `Llevas ${money(used)}`;
      if (msg){
        msg.textContent = (pct >= 100)
          ? '🎉 ¡Felicidades! Tu pedido tiene envío gratis 🍼✨'
          : `🚚 Agrega ${money(left)} para obtener envío gratis 🛍️`;
      }

      return cart;
    } catch (e){
      console.error('[pe-freeship] refresh error', e);
    }
  }

  async function refreshAll(){
    const els = document.querySelectorAll('[data-pe-freeship]');
    if(!els.length) return;
    let lastCart = null;
    for (const el of els) lastCart = await refreshEl(el);
    return lastCart;
  }

  function mount(el){
    if(S.mounted.has(el)) return;
    S.mounted.add(el);

    // Primer cálculo
    refreshEl(el);

    // Observa el form de carrito cercano (si existe)
    const form = el.closest('form[action="/cart"]') || document.querySelector('form[action="/cart"]');
    if (form){
      const mo = new MutationObserver(()=> setTimeout(()=>refreshEl(el), 250));
      mo.observe(form, { childList: true, subtree: true });
    }
  }

  function scan(){
    document.querySelectorAll('[data-pe-freeship]').forEach(mount);
  }

  function hook(){
    if (S.hooked) return;
    S.hooked = true;

    // fetch
    if (window.fetch && !window.fetch.__peFS2){
      const _f = window.fetch;
      window.fetch = function(resource, config){
        const url = (typeof resource==='string') ? resource : (resource && resource.url) || '';
        const hit = typeof url==='string' && (url.includes('/cart') || url.includes('sections='));
        return _f.apply(this, arguments).then(res=>{
          if (hit) {
            // ráfaga: refrescar varias veces por si el tema re-renderiza en oleadas
            setTimeout(refreshAll, 120);
            setTimeout(refreshAll, 350);
            setTimeout(refreshAll, 800);
          }
          return res;
        });
      };
      window.fetch.__peFS2 = true;
    }

    // XHR
    if (window.XMLHttpRequest && !window.XMLHttpRequest.__peFS2){
      const X = window.XMLHttpRequest.prototype;
      const open = X.open, send = X.send; let last=false;
      X.open = function(method, url){ last = typeof url==='string' && (url.includes('/cart') || url.includes('sections=')); return open.apply(this, arguments); };
      X.send = function(){ this.addEventListener('load', ()=>{ if(last){ setTimeout(refreshAll, 120); setTimeout(refreshAll, 500); } }); return send.apply(this, arguments); };
      window.XMLHttpRequest.__peFS2 = true;
    }

    // Inputs de cantidad y botones +/-
    document.addEventListener('change', (e)=>{
      const t = e.target;
      if (t && t.name && t.name.indexOf('updates')===0) {
        setTimeout(refreshAll, 200);
        setTimeout(refreshAll, 700);
      }
    });
    document.addEventListener('click', (e)=>{
      if (e.target && e.target.closest('.quantity__button')) {
        setTimeout(refreshAll, 200);
        setTimeout(refreshAll, 700);
      }
    });

    // Eventos comunes de temas/sections
    ['cart:updated','cart:change','theme:cart:change','ajaxProduct:added','open:cart','request:complete','shopify:section:load']
      .forEach(ev => document.addEventListener(ev, ()=> { setTimeout(refreshAll, 150); setTimeout(refreshAll, 600); }));

    // MutationObserver global: detectar nuevas barras inyectadas (drawer)
    const mo = new MutationObserver((muts)=>{
      let found = false;
      for (const m of muts){
        if (m.type==='childList'){
          m.addedNodes && m.addedNodes.forEach(n=>{
            if (n.nodeType===1 && (n.hasAttribute?.('data-pe-freeship') || n.querySelector?.('[data-pe-freeship]'))) found = true;
          });
        }
      }
      if (found){ scan(); setTimeout(refreshAll, 100); }
    });
    mo.observe(document.body, { childList: true, subtree: true });

    // Polling inteligente: si cambia el hash del carrito, lanzamos una ráfaga
    async function smartPoll(){
      if (S.busy) return;
      S.busy = true;
      try{
        const c = await getCart();
        const h = cartHash(c);
        if (h !== S.lastHash){
          S.lastHash = h;
          log('Cart cambió, ráfaga de refrescos');
          // ráfaga de refrescos por 3s
          setTimeout(refreshAll, 0);
          setTimeout(refreshAll, 300);
          setTimeout(refreshAll, 1000);
          setTimeout(refreshAll, 2000);
        }
      }catch(e){/* noop */}
      finally{ S.busy = false; }
    }
    // cada 4s comprobamos cambios de carrito
    setInterval(smartPoll, 4000);

    // Refrescar al volver de background
    document.addEventListener('visibilitychange', ()=>{ if(!document.hidden) setTimeout(refreshAll, 200); });

    // Exponer helpers
    window.PE_FreeShip = { refreshAll, refreshEl: refreshEl };
  }

  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', ()=>{ scan(); hook(); refreshAll(); });
  } else {
    scan(); hook(); refreshAll();
  }
})();
